import React from "react";
import { Navigate, useOutlet } from "react-router-dom";
import Login from "pages/Login/Login";
import Loader from "components/Loader/Loader";
import useSession from "../hooks/useSession";
import { supabase } from "../supbaseClient";

const ProtectedRoute = () => {
  const session = useSession();

  const outlet = useOutlet();

  const logout = async () => {
    await supabase.auth.signOut();
  };

  if (session == "loading") {
    return <Loader />;
  }

  if (
    session &&
    session?.user?.email?.split("@")[1] !== "workhack.ai" &&
    session?.user?.email?.split("@")[1] !== "metaforms.ai"
  ) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        Not authorized.{" "}
        <a href="#" onClick={logout}>
          Click here
        </a>{" "}
        to login with a workhack or metaforms account.
      </div>
    );
  }

  if (location.pathname == "/") {
    return <Navigate to={"/config/"} />;
  }

  if (session) {
    return outlet;
  }

  return <Login />;
};

export default ProtectedRoute;
